export default (vm) => {
    return vm.profile.customerId
        ? vm.$iotDataProvider.get('permissions')
            .then((permissions) => permissions)
            .catch(() => ([]))
        : Promise.resolve([]);
};
